import { UnionMap, UnionValueMap } from '../types/union-map';
import { isString } from '../utilities/string';

export type RemoteFlagName = 'DevBoxLimits'; //This is an example flag.

export const RemoteFlagName: UnionMap<RemoteFlagName> = {
    DevBoxLimits: 'DevBoxLimits', //This is an example flag.
};

export type FeatureFlagName =
    | 'EnableBetaDataPlane'
    | 'UnderDevelopment'
    | 'UseNonPreauthorizedScopes'
    | 'LogVerbose'
    | 'EnableThemeModeToggle'
    | 'SingleDevCenterMode'
    | 'DisplayNames'
    | 'RoundTripTime'
    | 'EnableDiscoveryService'
    | 'EnableIntrinsicTasksForCustomization'
    | 'EnableGuestUser'
    | 'EnableTakeSnapshot'
    | 'EnableConnectWithVSCode';

export const FeatureFlagName: UnionMap<FeatureFlagName> = {
    EnableBetaDataPlane: 'EnableBetaDataPlane',
    UnderDevelopment: 'UnderDevelopment',
    UseNonPreauthorizedScopes: 'UseNonPreauthorizedScopes',
    LogVerbose: 'LogVerbose',
    EnableThemeModeToggle: 'EnableThemeModeToggle',
    SingleDevCenterMode: 'SingleDevCenterMode',
    DisplayNames: 'DisplayNames',
    RoundTripTime: 'RoundTripTime',
    EnableDiscoveryService: 'EnableDiscoveryService',
    EnableIntrinsicTasksForCustomization: 'EnableIntrinsicTasksForCustomization',
    EnableGuestUser: 'EnableGuestUser',
    EnableTakeSnapshot: 'EnableTakeSnapshot',
    EnableConnectWithVSCode: 'EnableConnectWithVSCode',
};

export type FeatureFlag = Lowercase<FeatureFlagName>;

export const FeatureFlag: UnionValueMap<FeatureFlagName, FeatureFlag> = {
    EnableBetaDataPlane: 'enablebetadataplane',
    UnderDevelopment: 'underdevelopment',
    UseNonPreauthorizedScopes: 'usenonpreauthorizedscopes',
    LogVerbose: 'logverbose',
    EnableThemeModeToggle: 'enablethememodetoggle',
    SingleDevCenterMode: 'singledevcentermode',
    DisplayNames: 'displaynames',
    RoundTripTime: 'roundtriptime',
    EnableDiscoveryService: 'enablediscoveryservice',
    EnableIntrinsicTasksForCustomization: 'enableintrinsictasksforcustomization',
    EnableGuestUser: 'enableguestuser',
    EnableTakeSnapshot: 'enabletakesnapshot',
    EnableConnectWithVSCode: 'enableconnectwithvscode',
};

export const NameForFeatureFlag: UnionValueMap<FeatureFlag, FeatureFlagName> = {
    enablebetadataplane: 'EnableBetaDataPlane',
    underdevelopment: 'UnderDevelopment',
    usenonpreauthorizedscopes: 'UseNonPreauthorizedScopes',
    logverbose: 'LogVerbose',
    enablethememodetoggle: 'EnableThemeModeToggle',
    singledevcentermode: 'SingleDevCenterMode',
    displaynames: 'DisplayNames',
    roundtriptime: 'RoundTripTime',
    enablediscoveryservice: 'EnableDiscoveryService',
    enableintrinsictasksforcustomization: 'EnableIntrinsicTasksForCustomization',
    enableguestuser: 'EnableGuestUser',
    enabletakesnapshot: 'EnableTakeSnapshot',
    enableconnectwithvscode: 'EnableConnectWithVSCode',
};

export const isFeatureFlag = (value: unknown): value is FeatureFlag => {
    if (!isString(value)) {
        return false;
    }

    switch (value.toLowerCase()) {
        case FeatureFlag.EnableBetaDataPlane:
        case FeatureFlag.UnderDevelopment:
        case FeatureFlag.UseNonPreauthorizedScopes:
        case FeatureFlag.LogVerbose:
        case FeatureFlag.EnableThemeModeToggle:
        case FeatureFlag.SingleDevCenterMode:
        case FeatureFlag.DisplayNames:
        case FeatureFlag.RoundTripTime:
        case FeatureFlag.EnableDiscoveryService:
        case FeatureFlag.EnableIntrinsicTasksForCustomization:
        case FeatureFlag.EnableGuestUser:
        case FeatureFlag.EnableTakeSnapshot:
        case FeatureFlag.EnableConnectWithVSCode:
            return true;
        default:
            return false;
    }
};
